import api from './api';

export async function downloadCsv(
  workspaceId: string,
  actionType: string,
  startDate: string,
  endDate: string,
) {
  try {
    const response = await api.get(
      `workspace/${workspaceId}/actions/${actionType}/export/${startDate}/${endDate}`,
      {
        responseType: 'blob',
      },
    );
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute(
      'download',
      `${actionType}_actions_${startDate}_${endDate}.csv`,
    ); // Set the file name
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    return error;
  }
}
